



























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// components
import SelectBackgroundModal from "@/components/templates/modals/SelectBackgroundModal.vue";
// types
import { TemplateBg } from "@/services/templates/types";
// validation
import validate from "@/directives/validate";
import { settingsValidators } from "@/components/templates/validators";
import { backgroundFields } from "@/components/templates/fields/backgroundFields";

@Component({
    components: {
        SelectBackgroundModal
    },
    directives: {
        validate
    }
})
export default class TemplateBackground extends Vue {
    @Prop() background!: TemplateBg;
    @Prop() collapseState!: boolean;

    // local state
    localCollapseState = true;
    localSettings = { backgroundId: "", backgroundName: "" } as TemplateBg;
    validators = settingsValidators;
    items = [] as Array<TemplateBg>;
    validateBackground = false;
    // Watchers
    @Watch("background")
    onPropertyChanged(value: boolean, oldValue: any) {
        this.localSettings = this.background;
        if (this.localSettings.backgroundId && !this.validateBackground) {
            this.items.push(this.localSettings);
        }
    }

    fields = backgroundFields;

    // lifecycle hooks
    mounted() {
        this.localCollapseState = this.collapseState;
    }
    // computed

    // methods
    addBackground() {
        (this.$refs.selectBackgroundModal as any).open();
    }

    deleteBackground() {
        this.items.pop();
        this.localSettings = { backgroundId: "", backgroundName: "" } as TemplateBg;
        this.validateBackground = false;
    }

    // events && callbacks
    backgroundSelected(background: any) {
        this.localSettings.backgroundName = background.name;
        this.localSettings.backgroundId = background.id;
        this.items.push(this.localSettings);
    }

    emitData() {
        this.validateBackground = true;
        this.$emit("backgroundUpdated", this.localSettings);
    }

    setState(state: boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "TemplateBackground", state: state });
    }

    goToContentRoute() {
        return {
            name: "updatebackground",
            params: { backgroundId: this.localSettings.backgroundId }
        };
    }
}
